let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9g1y5")).then(() => parcelRequire('lKadn'));